import React, { Component } from 'react'
import { connect } from 'react-redux'
import BarraNavegacao from './BarraNavegacao'
import ModalAlterarSenhaUsuario from '../usuario/empresa/ModalAlterarSenhaUsuario';

export class Template extends Component {
  render () {
    return (
      <div style={{ display: this.props.authentication.isAuthenticated ? 'inline' : 'none' }}>
        <BarraNavegacao/>
        <ModalAlterarSenhaUsuario/>
      </div>
    )
  }
}

const mapStateToProps = ({ authentication }) => ({ authentication });

export default connect(mapStateToProps)(Template)
